import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import AllRoutes from "./routes/Allroutes";
import { AuthProvider } from "./providers/AuthProvider";

const App = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}>
      <AuthProvider>
        <AllRoutes />
      </AuthProvider>
    </GoogleReCaptchaProvider>
  );
};

export default App;
